export const baseUrl =
  (import.meta.env.VITE_REST_API_BASE_URL && import.meta.env.VITE_REST_API_BASE_URL.trim().length > 0
    ? import.meta.env.VITE_REST_API_BASE_URL
    : import.meta.env.VITE_API_HOST) || 'http://localhost:8080';

export const apiFetch = async (path, { method = 'GET', token, body } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${baseUrl}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  });

  if (!res.ok) {
    const text = await res.text();
    const error = new Error(`API error ${res.status}: ${text}`);
    error.status = res.status;
    try {
      error.code = JSON.parse(text)?.code;
    } catch {
      error.code = null;
    }
    throw error;
  }

  if (res.status === 204) return null;
  return res.json().catch(() => res);
};
